import CityManagementPage from "./shared/CityManagementPage";
import { allCityConfigs } from "./shared/cityConfigExtended";

export default function Essex() {
  return <CityManagementPage config={allCityConfigs.essex} />;
}